interface SearchLocation {
  search: string;
}

interface RoutePosition {
  positionId: number;
  displayName: string;
}

export interface LinkParams {
  arrivalPos: number | null;
  departurePos: number | null;
  departureDate: string | null;
  returnDate: string | null;
}

export interface ResolvedRoute {
  arrival: RoutePosition;
  departure: RoutePosition;
}

function parsePositionId(value: string | null): number | null {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;

  const positionId = Number(value);
  return Number.isSafeInteger(positionId) ? positionId : null;
}

export function getAbTestParameters(location: SearchLocation): string {
  const search = new URLSearchParams(location.search);
  const params = search.get('abTestParameters')?.split(',');

  return params ? JSON.stringify(params) : '';
}

export function getLinksParams(search: URLSearchParams): LinkParams {
  return {
    arrivalPos: parsePositionId(search.get('arrivalPos')),
    departurePos: parsePositionId(search.get('departurePos')),
    departureDate: search.get('departureDate'),
    returnDate: search.get('returnDate'),
  };
}

export function resolveRoute(
  departureInfo: RoutePosition | null,
  arrivalInfo: RoutePosition | null,
  departureId: number | null,
  arrivalId: number | null
): ResolvedRoute | null {
  if (!departureInfo || !arrivalInfo) return null;
  if (departureInfo.positionId !== departureId) return null;
  if (arrivalInfo.positionId !== arrivalId) return null;

  return { arrival: arrivalInfo, departure: departureInfo };
}
